import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../shared/grid"
import BackgroundImage from "gatsby-background-image"
import Statistics from "./stats"
import { HeroOverlay } from "./hero.style"
import Breakpoints from "../shared/breakpoints"
import { Title, Description } from "../shared/hero.style"
import Spacer from "../../design-system/atoms/layout-primitives/spacer.tsx"

const Hero = () => {
  const { desktopImage, tabletImage, mobileImage } = useStaticQuery(
    graphql`
      query {
        desktopImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Hero Images/hero_desktop.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        tabletImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Hero Images/hero_tablet.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mobileImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Hero Images/hero_mobile.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const images = [
    mobileImage.childImageSharp.fluid,
    {
      ...tabletImage.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.md})`,
    },
    {
      ...desktopImage.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.lg})`,
    },
  ]

  return (
    <BackgroundImage fluid={images} loading="eager" fadeIn={false}>
      <Grid overlayStyle={HeroOverlay}>
        <Title>Responsive Web App</Title>
        <Description>
          The Responsive Web App enables users to search, discover, and navigate
          complex venues. Built with Mappedin’s Web SDK, the responsive design
          allows visitors to access indoor maps across any device.
        </Description>
      </Grid>
      <Spacer
        variants={[{ backgroundColor: "rgba(240, 240, 240, 0.7)" }]}
        height={{ sm: "1px", md: "1px", lg: "1px" }}
      />
      <Statistics />
    </BackgroundImage>
  )
}

export default Hero
